import { useLanguage } from "@/i18n/LanguageContext";
import { Button } from "@/components/ui/button";

export default function DownloadApp() {
  const { t } = useLanguage();

  return (
    <section
      id="download"
      data-testid="download-section"
      className="py-24 lg:py-32 bg-red-600"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Text */}
          <div className="space-y-8">
            <div className="inline-block">
              <span
                data-testid="download-tag"
                className="text-xs font-bold tracking-[0.2em] uppercase text-white/70 font-body"
              >
                {t.downloadApp.tag}
              </span>
              <div className="w-12 h-0.5 bg-white/40 mt-1" />
            </div>

            <h2
              data-testid="download-title"
              className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-none text-white font-heading"
            >
              {t.downloadApp.title}
            </h2>

            <p
              data-testid="download-subtitle"
              className="text-base sm:text-lg leading-relaxed text-white/80 font-body max-w-md"
            >
              {t.downloadApp.subtitle}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              {/* Google Play Button */}
              <a
                href="https://play.google.com/store/apps/details?id=com.rentcoming.app"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="google-play-btn"
                className="inline-flex items-center gap-3 bg-white text-gray-900 px-6 py-4 hover:bg-gray-100 transition-colors duration-200 group"
              >
                <svg viewBox="0 0 24 24" className="w-7 h-7 flex-shrink-0" fill="currentColor">
                  <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.199l2.302 2.302a1 1 0 0 1 0 1.38l-2.302 2.302L15.196 12l2.502-2.492zM5.864 1.463l10.937 6.333-2.302 2.302-8.635-8.635z" />
                </svg>
                <div>
                  <div className="text-[10px] uppercase tracking-wider font-body text-gray-500">
                    Download via
                  </div>
                  <div className="text-base font-bold font-heading -mt-0.5">
                    {t.downloadApp.googlePlay}
                  </div>
                </div>
              </a>

              {/* App Store Button */}
              <a
                href="https://apps.apple.com/ci/app/rentcoming/id6762308453"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="app-store-btn-ios"
                className="inline-flex items-center gap-3 bg-white text-gray-900 px-6 py-4 hover:bg-gray-100 transition-colors duration-200 group"
              >
                <svg viewBox="0 0 24 24" className="w-7 h-7 flex-shrink-0" fill="currentColor">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                </svg>
                <div>
                  <div className="text-[10px] uppercase tracking-wider font-body text-gray-500">
                    Download via
                  </div>
                  <div className="text-base font-bold font-heading -mt-0.5">
                    {t.downloadApp.appStore}
                  </div>
                </div>
              </a>
            </div>
          </div>

          {/* Right - App Mockup */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative w-64 sm:w-72 lg:w-80">
              <img
                src="https://static.prod-images.emergentagent.com/jobs/e528f734-065a-4c46-925b-e9b3fc489adc/images/6cbf88fbfc0b27d4518dd8f99b54135fdaa32bbfc57c94af48de332001d61241.png"
                alt="RentComing App"
                className="w-full drop-shadow-2xl"
                data-testid="app-mockup-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
